/* eslint-disable
    func-names,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model', 'UpcomingInvoiceVM', 'benchLocation'];
const factory = function (Model, UpcomingInvoiceVM, benchLocation) {
  class UpcomingInvoice extends Model {
    static initClass() {
      this.prototype.clientId = null;
      this.prototype.$resource = 'billing';
      this.prototype.$idName = 'clientId';
      this.prototype.$viewModelType = UpcomingInvoiceVM;
    }

    // TODO: this will be unnessecary once we can use $url from the develop branch.
    $fetch(params = {}) {
      return this.$apiCall({
        method: 'GET',
        url: `${this.$resource}.json/client/${this.$storeId()}/upcoming_invoice`,
        params,
      }).then(res => {
        if (res.data != null) {
          this.$set(this.$serialize(res.data));
        }
        return res;
      });
    }

    $serialize(data) {
      const newData = angular.copy(data);
      const dateKeys = ['date', 'periodEnd', 'periodStart'];
      dateKeys.forEach(key => (newData[key] = data[key] ? new Date(data[key] * 1000) : ''));

      if (data.chargeDate) {
        const invoiceDate = data.chargeDate.split('-').map(Number);
        newData.invoiceDate = new Date(invoiceDate[0], invoiceDate[1] - 1, invoiceDate[2]);
      }

      return newData;
    }

    $deserialize(data) {
      const newData = angular.copy(data);

      // convert dates to timestamp
      Object.keys(data).forEach(key => {
        if (data[key] instanceof Date) {
          return (newData[key] = Math.floor(data[key].getTime() / 1000));
        }
      });

      return newData;
    }
  }
  UpcomingInvoice.initClass();

  return UpcomingInvoice;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name, require('data/viewModel/upcomingInvoice').name];

module.exports = angular
  .module('bench.data.model.upcomingInvoice', moduleDeps)
  .factory('UpcomingInvoice', factory);
